<template >
    <div class="media">
        media
    </div>
</template>
<script>
export default {
    name: 'media'
}
</script>
<style lang="">
    
</style>